import { DATE_FORMAT_DEFAULT } from '../../../shared/constants/values'
import { createDate } from '../../helpers/date/createDate'

const monthNames = [
  'Января',
  'Февраля',
  'Марта',
  'Апреля',
  'Мая',
  'Июня',
  'Июля',
  'Августа',
  'Сентября',
  'Октября',
  'Ноября',
  'Декабря',
]

export const formateDate = (date: Date | string, format: string = DATE_FORMAT_DEFAULT) => {
  const createdDate = createDate({ date })

  return format
    .replace(/\bYYYY\b/, createdDate.year.toString())
    .replace(/\bMM\b/, createdDate.monthNumber.toString().padStart(2, '0'))
    .replace(/\bMMMM\b/, monthNames[createdDate.monthNumber - 1])
    .replace(/\bDD\b/, createdDate.dayNumber.toString().padStart(2, '0'))
}
